import initialiseLoyaltyPurchasePointsCheckout from 'actions/loyalty/initialiseLoyaltyPurchasePointsCheckout'
import LayoutContainer from 'components/Common/LayoutContainer'
import { useAppDispatch } from 'hooks/reduxHooks'
import { rem } from 'polished'
import { useCallback, useMemo } from 'react'
import styled from 'styled-components'
import LoyaltyPurchasePointsHeroSection from './LoyaltyPurchasePointsHeroSection'
import LoyaltyPurchasePointsPanel from './LoyaltyPurchasePointsPanel'
import LoyaltyPurchasePointsWhatYouNeedToKnow from './LoyaltyPurchasePointsWhatYouNeedToKnow'

const PageBody = styled.div`
  padding: ${rem(48)} 0;
  background-color: ${props => props.theme.palette.neutral.surface.lightBackground};
`

function LoyaltyPurchasePointsPage() {
  const dispatch = useAppDispatch()

  const onContinue = useCallback((offerId: string) => {
    dispatch(initialiseLoyaltyPurchasePointsCheckout(offerId))
  }, [dispatch])

  const panel = useMemo(() => <LoyaltyPurchasePointsPanel onContinue={onContinue} />, [onContinue])

  return <div>
    <LoyaltyPurchasePointsHeroSection panel={panel} />
    <PageBody>
      <LayoutContainer variant="medium">
        <LoyaltyPurchasePointsWhatYouNeedToKnow />
      </LayoutContainer>
    </PageBody>
  </div>
}

export default LoyaltyPurchasePointsPage
